// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/account_management/marketing_consent/firstparty/v1/update_client_consents.proto

/* oxlint-disable */
import { ApiConsent } from "./get_client_consents";

/** Request message for updating one or more marketing consent preferences. */
export interface ApiUpdateClientConsentsRequest {
  /** The consents to update. Must contain at least one entry. */
  readonly consents: readonly ApiConsent[];
}

/** Response message containing the updated marketing consent preferences. */
export interface ApiUpdateClientConsentsResponse {
  /** The full list of marketing consents for the client after the update. */
  readonly consents: readonly ApiConsent[];
}

export const ApiUpdateClientConsentsRequest: MessageFns<ApiUpdateClientConsentsRequest> = {
  fromJSON(object: any): ApiUpdateClientConsentsRequest {
    return {
      consents: globalThis.Array.isArray(object?.consents)
        ? object.consents.map((e: any) => ApiConsent.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ApiUpdateClientConsentsRequest): unknown {
    const obj: any = {};
    if (message.consents?.length) {
      obj.consents = message.consents.map((e) => ApiConsent.toJSON(e));
    }
    return obj;
  },
};

export const ApiUpdateClientConsentsResponse: MessageFns<ApiUpdateClientConsentsResponse> = {
  fromJSON(object: any): ApiUpdateClientConsentsResponse {
    return {
      consents: globalThis.Array.isArray(object?.consents)
        ? object.consents.map((e: any) => ApiConsent.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ApiUpdateClientConsentsResponse): unknown {
    const obj: any = {};
    if (message.consents?.length) {
      obj.consents = message.consents.map((e) => ApiConsent.toJSON(e));
    }
    return obj;
  },
};

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
